import { Box, Flex, Icon } from "@chakra-ui/react";
import moment from "moment";
import { getLabelPagamento, getLabelStatus } from "../util";
import { useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import colors from "core/resources/theme/colors";

export default function Card({ data }: any) {
  const navigate = useNavigate();
  return (
    <Flex
      onClick={() => navigate(`/minhas-compras/${data.id}`)}
      cursor="pointer"
      w="100%"
      flexDir={"column"}
      p={"0.5rem"}
      rounded={10}
      gap={2}
      border="1px #397DC5 solid"
      borderBottom="3px #397DC5 solid"
    >
      <Flex flexDir={["column", "row", "row"]} gap={2}>
        <Box w={["100%", "50%", "50%"]}>
          <Flex flex={0.8} fontSize="16px" color="gray.500">
            #
          </Flex>{" "}
          <Flex flex={0.8} fontSize="16px">
            {data.id}
          </Flex>
        </Box>
        <Box>
          <Flex flex={0.8} fontSize="16px" color="gray.500">
            EVENTO
          </Flex>{" "}
          <Flex flex={0.8} fontSize="16px">
            {data.eventoNome}
          </Flex>
        </Box>
      </Flex>{" "}
      <Flex flexDir={["column", "row", "row"]} gap={2}>
        <Box w={["100%", "50%", "50%"]}>
          <Flex flex={0.8} fontSize="16px" color="gray.500">
            DATA E HORA DA COMPRA
          </Flex>{" "}
          <Flex flex={0.8} fontSize="16px">
            {moment(data.dataHora).format("DD/MM/YYYY HH:mm")}
          </Flex>
        </Box>
        <Box>
          <Flex flex={0.8} fontSize="16px" color="gray.500">
            STATUS
          </Flex>{" "}
          <Flex flex={0.8} fontSize="16px">
            {getLabelStatus(data.statusNome)}
          </Flex>
        </Box>
      </Flex>{" "}
      <Flex flexDir={["column", "column", "row"]} gap={2}>
        <Box w={["100%", "50%", "50%"]}>
          <Flex flex={0.8} fontSize="16px" color="gray.500">
            FORMA DE PAGAMENTO
          </Flex>{" "}
          <Flex flex={0.8} fontSize="16px">
            {getLabelPagamento(data.modalidadeNome)}
          </Flex>
        </Box>
        <Box>
          <Flex flex={0.8} fontSize="16px" color="gray.500">
            TOTAL
          </Flex>{" "}
          <Flex flex={0.8} fontSize="16px">
            {data.valorTotal.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })}
          </Flex>
        </Box>
        <Box>
          <Flex
            flex={0.8}
            fontSize="16px"
            color="white"
            border={`1px solid ${colors.newBlue}`}
            borderRadius={12}
            alignItems="center"
            bg={colors.newBlue}
            justifyContent="center"
            gap={4}
          >
            <Icon as={FaEye} color="white" fontSize="20px" />
            Visualizar
          </Flex>
        </Box>
      </Flex>
    </Flex>
  );
}
